var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"z-slider",attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{style:([_vm.styles]),attrs:{"r":"51","cx":"50","cy":"50"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }